import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ModalService } from '@app/core/services/modal.service';
import { SrCrewGet, SrCrewService } from '@app/services/sr-crew.service';

@Component({
    selector: 'tt-sr-crew',
    templateUrl: './sr-crew.component.html',
    styleUrls: ['./sr-crew.component.css'],
    standalone: false,
})
export class SrCrewComponent implements OnInit {
    public page?: SrCrewGet;
    public saving = false;

    constructor(
        private readonly crew: SrCrewService,
        private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        this.page = await this.crew.getCrew({
            resource_id: String(this.navigator?.params['resource_id'] ?? ''),
            srcrew_keyno: String(this.navigator?.params['srcrew_keyno'] ?? '0'),
        });
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving) return;
        this.saving = true;
        try {
            const response = await this.crew.saveCrew(this.page);
            if (response.errorcode !== '0') {
                await this.modal.show({ type: 'warning', title: 'Varsel', message: response.errormessage, buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
            } else { await this.navigator?.back(); }
        } finally { this.saving = false; }
    }
}
